<template>
  <div class="wrapper">
    <span class="w-title">{{ adding?`新建${pageName}`:(editing ? `修改${pageName}` : `${pageName}详情`) }}</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <div class="detail-btns">
        <v-btn color="info" flat @click="cancel">&lt; 返回{{ pageName }}列表</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!adding" color="error" flat outline @click="deleteThisItem">删除</v-btn>
        <v-btn v-if="detailing" color="info" flat class="btn-to-edit" @click="toEdit">去编辑 &gt;</v-btn>
      </div>
      <div class="form-panel">
        <div class="form-panel-head">基本信息</div>
        <div class="form-panel-body">
          <v-container fluid grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">事务所名称:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.name"
                  v-model="item.name"
                  :label="detailing?'':'请输入事务所名称'"
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">有效期:</label>
              </v-flex>
              <v-flex xs9 md4 style="display: flex;align-items: center">
                <span v-if="detailing" class="span">{{ item.effectiveStart }}</span>
                <v-menu
                  v-else
                  v-model="showStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      ref="form.effectiveStart"
                      v-model="item.effectiveStart"
                      :label="detailing?'':'开始日期'"
                      readonly
                      outline
                      solo
                      style="width:45%"
                      :rules="[rules.required]"
                      :disabled="detailing"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.effectiveStart"
                    locale="zh-cn"
                    @input="showStartDate = false"
                  ></v-date-picker>
                </v-menu>
                <span class="mx-2 span" >至</span>
                <span v-if="detailing" class="span">{{ item.effectiveEnd }}</span>
                <v-menu
                  v-else
                  v-model="showEndDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      ref="form.effectiveEnd"
                      v-model="item.effectiveEnd"
                      :label="detailing?'':'结束日期'"
                      readonly
                      outline
                      solo
                      style="width:45%"
                      :rules="[rules.required]"
                      :disabled="detailing"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.effectiveEnd"
                    locale="zh-cn"
                    @input="showEndDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </div>
    </v-container>

    <v-container fluid grid-list-md class="pa-0 my-5">
      <v-layout>
        <v-flex xs3 md4></v-flex>
        <v-flex xs6 md4 style="display:flex;justify-content: space-around">
          <v-btn outline @click="cancel">返回</v-btn>
          <v-btn v-if="!detailing" color="info" @click="save">保存</v-btn>
        </v-flex>
        <v-flex xs3 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import axios from "../axios";
  import {mapState, mapActions} from "vuex";

  export default {
    computed:{
      ...mapState({
        showLoading: state => state.showLoading,
      }),
      id() {
        return this.$route.params.firmId;
      },
      adding() {
        return !this.id;
      },
      editing() {
        return (!!this.id) && this.$route.name === "firm-form-edit"
      },
      detailing() {
        return (!!this.id) && this.$route.name === "firm-form-detail"
      },
      deleteIdObject() {
        let arr = [];
        arr.push(this.id);
        return {firmIds: arr};
      },
      isValidDate(){
        if(this.item.effectiveStart && this.item.effectiveEnd){
          return new Date(this.item.effectiveEnd).getTime() - new Date(this.item.effectiveStart).getTime() > 0 ;
        }else{
          return false;
        }
      }
    },
    data: () => ({
      urlName: 'firms',
      pageName: '事务所',
      rules: {
        required: value => !!value || "必填",
      },
      hasErrors: false,
      item: {},
      showStartDate: false,
      showEndDate: false,
    }),
    methods:{
      ...mapActions(["setLoading"]),
      validate() {
        this.hasErrors = false;

        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      },
      cancel() {
        this.$router.push({name: this.urlName});
      },
      toEdit() {
        this.$router.push("edit");
      },
      deleteThisItem() {
        this.$confirm("确定删除?").then(
          res => {
            if (res) {
              this.setLoading(true);
              axios
                .post(`/${this.urlName}/delete`, this.deleteIdObject)
                .then(() => {
                  this.setLoading(false);
                  this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                      this.cancel();
                    }
                  );
                })
                .catch(reason => {
                  this.$confirm(reason.response.data.message, {buttonFalseText: null});
                  this.setLoading(false);
                });
            }
          }
        );
      },
      save() {
        this.validate();
        if (!this.hasErrors) {
          //去掉录入后，又不想录入 输入的空项
          for (let i in this.item) {
            if (this.item[i] === "") {
              delete this.item[i];
            }
          }

          if(!this.isValidDate){
            this.$confirm("开始日期不能晚于结束日期", {buttonFalseText: null});
            return;
          }

          if (this.editing) {
            //保存
            this.putEditHandler();
          } else {
            //添加
            this.postAddHandler();
          }
        }
      },
      postAddHandler() {
        this.setLoading(true);
        axios.post(`/${this.urlName}`, this.item)
          .then(() => {
            this.setLoading(false);
            this.$confirm("创建成功", {buttonFalseText: null}).then(() => {
              this.cancel();
            });
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
      putEditHandler() {
        this.setLoading(true);
        axios.put(`/${this.urlName}/` + this.id, this.item)
          .then(() => {
            this.setLoading(false);
            this.$confirm("修改成功", {buttonFalseText: null}).then(() => {
              this.cancel();
            });
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
      getDetailHandler() {
        this.setLoading(true);
        axios.get(`/${this.urlName}/` + this.id)
          .then(res => {
            this.item = res.data;
            this.setLoading(false);
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
    },
    created() {
      if (this.editing || this.detailing) {
        this.getDetailHandler();
      } else {
        this.item = {
          name:null,
          effectiveStart:null,
          effectiveEnd:null,
        }
      }
    }

  }
</script>

<style scoped>
  .span{
    height: 40px;display: block;
  }
</style>